export const Active = {
    name: 'Active',
    value: 'ACTIVE',
    sequence: 1,
};
export const Inactive = {
    name: 'Inactive',
    value: 'INACTIVE',
    sequence: 2,
};
export const OnHold = {
    name: 'On Hold',
    value: 'ON_HOLD',
    sequence: 3,
};
export const Deleted = {
    name: 'Deleted',
    value: 'DELETED',
    sequence: 4,
};
const Basic = [Active, Inactive, OnHold, Deleted];
const BasicByValue = Basic.reduce((hash, status) => {
    hash[status.value] = status;
    return hash;
}, {});
const BasicProps = Object.keys(BasicByValue);
export default {
    Basic,
    BasicByValue,
    BasicProps,
    Active,
    Inactive,
    OnHold,
    Deleted,
};
